import './SkeletonSlide.scss';

const SkeletonSlide = () => {
   return (
      <div className='skeleton-slide'>
         <div className='skeleton-image'></div>
         <div className='skeleton-text'></div>
      </div>
   );
};

export default SkeletonSlide;
